module.exports = __webpack_public_path__ + "img/caijiqi03.958ea9aa.png";